import styled from '@emotion/styled';
import { theme } from '@vfit/shared/themes';

export const FillBorder = styled.div`
  height: 3px;
  background: transparent;
  border-left: ${theme.borderWidth.thin} solid ${theme.colors.border.default};
  border-right: ${theme.borderWidth.thin} solid ${theme.colors.border.default};
  margin-top: -3px;
`;

export const SuggestionsWrapper = styled.div`
  position: relative;
  background-color: ${theme.colors.bg.primary};
  border-radius: 6px;
`;

export const Suggestions = styled.ul<{ isError: boolean }>`
  z-index: 3;
  overflow: hidden;
  position: absolute;
  top: 0;
  margin: 0;
  width: 100%;
  width: fill-available;
  background-color: ${theme.colors.bg.primary};
  padding: 0;
  border-left: ${theme.borderWidth.thin} solid ${theme.colors.border.default};
  border-right: ${theme.borderWidth.thin} solid ${theme.colors.border.default};
  border-bottom: ${theme.borderWidth.thin} solid ${theme.colors.border.default};
  border-radius: 0 0 5px 5px;

  > div::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  > div::-webkit-scrollbar-thumb {
    background: #d8d8d8;
    border-radius: 10px;
  }

  > div::-webkit-scrollbar-track {
    background: ${theme.colors.bg.primary};
    border-radius: 10px;
  }
`;

